import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { FetchConfig, _fetch as fetch } from './fetch';
import { $Locale } from '@lemon8/web-app-shared/atom';

export const useFetch = (): ((url: string, config: FetchConfig) => Promise<any>) => {
  const { region } = useAtomValue($Locale);

  return useCallback(
    (url: string, config: FetchConfig) => {
      return fetch(url, config, { region, addCommonParams: true });
    },
    [region],
  );
};
